import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { SelectItem } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { Observable, Observer, forkJoin } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { Table } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../services/toast.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AjustaTamanhoCampoHelper } from '../../helpers/ajusta-tamanho-campo.helper';
import { TooltipModule } from 'primeng/tooltip';
import { GenericDialogComponent } from '../../shared/generic-dialog/generic-dialog.component';
import { ClassificacaoContaFilha } from '../../models/enums/classificacaoContaFilha.enum';
import { ContaFilhaService } from '../../services/conta-filha.service';
import { ContaFilha } from '../../models/contaFilha.model';
import { SaldoInicial } from '../../models/saldoInicial.model';
import { SaldoInicialService } from '../../services/saldo-inicial.service';
import { CalendarModule } from 'primeng/calendar';
import { DatePipe } from '@angular/common';
import { SpinnerService } from '../../services/spinner.service';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';

@Component({
  selector: 'app-saldo-inicial',
  standalone: true,
  imports: [
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    ReactiveFormsModule,
    CommonModule,
    ToastModule,
    ConfirmDialogModule,
    InputTextModule,
    TooltipModule,
    GenericDialogComponent,
    DropdownModule,
    CalendarModule,
    DatePipe,
    SpinnerServiceComponent
  ],
  providers: [ConfirmationService, DatePipe],
  templateUrl: './saldo-inicial.component.html',
  styleUrls: ['./saldo-inicial.component.scss'],
})
export class SaldoInicialComponent {
  @ViewChild('dt') dt: Table | undefined;
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();


  saldoInicialForm: FormGroup = new FormGroup({
    id: new FormControl(0),
    data: new FormControl(null, Validators.required),
    valor: new FormControl('', Validators.required),
    contaFilhaId: new FormControl(null, Validators.required),
  });
  classificacoes = ClassificacaoContaFilha;
  classificacaoOptions: SelectItem[] = [];
  saldoInicialArray: SaldoInicial[] = [];
  selectedSaldoInicial: SaldoInicial | null = null;
  saldoInicialDialog = false;
  contasFilhas: ContaFilha[] = [];
  isEdit = false;
  detailsDialogVisible = false;
  caminhoImagem = '../../../assets/img/undraw_annotation_re_h774.svg';
  isLoading = false;

  constructor(
    private datePipe: DatePipe,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private contaFilhaService: ContaFilhaService,
    private ajustaTamanhoCampoHelper: AjustaTamanhoCampoHelper,
    private saldoInicialService: SaldoInicialService,
    private spinnerService: SpinnerService,
  ) {
    this.loadInitialData();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Saldo Inicial');
    this.iconeChange.emit('pi pi-wallet');
  }

  private loadInitialData(): void {
    this.isLoading = true;
    this.spinnerService.show('Carregando saldo inicial...');
    forkJoin({
      saldosIniciais: this.saldoInicialService.getSaldoInicial(),
      contasFilhas: this.contaFilhaService.listaContasFilhas()
    }).subscribe({
      next: ({ saldosIniciais, contasFilhas }) => {
        this.saldoInicialArray = saldosIniciais;
        this.contasFilhasObserver.next?.(contasFilhas);
        this.isLoading = false;
        this.spinnerService.hide();
      },
      error: (err) => {
        this.isLoading = false;
        this.spinnerService.hide();
        this.retornarMensagemErro(err);
      }
    });
  }

  formataData(data: Date): string {
    return this.datePipe.transform(data, 'dd/MM/yyyy');
  }

  openNew(): void {
    this.saldoInicialForm.reset({
      id: 0,
    });
    this.saldoInicialDialog = true;
    this.isEdit = false;
  }

  onCancel(): void {
    this.saldoInicialDialog = false;
    this.saldoInicialForm.reset();
  }

  editSaldoInicial(saldoInicial: SaldoInicial): void {
    this.saldoInicialForm.patchValue(saldoInicial);
    this.saldoInicialDialog = true;
    this.isEdit = true;
  }

  deleteSaldoInicial(saldoInicial: SaldoInicial): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja deletar este saldo inicial?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.spinnerService.show('Excluindo saldo inicial...');
        this.saldoInicialService.deleteSaldoInicial(saldoInicial.id).subscribe({
          next: () => {
            this.retornarMensagemSucesso('Saldo Inicial excluído com sucesso.');
            this.loadInitialData();
          },
          error: (e) => {
            this.spinnerService.hide();
            this.retornarMensagemErro(e);
          },
        });
      },
    });
  }

  salvarSaldoInicial(): void {
    if (this.saldoInicialForm.valid) {
      const saldoInicialData = this.saldoInicialForm.value as SaldoInicial;

      let saveOperation: Observable<void>;
      if (this.isEdit) {
        saveOperation =
          this.saldoInicialService.updateSaldoInicial(saldoInicialData);
      } else {
        saveOperation =
          this.saldoInicialService.addSaldoInicial(saldoInicialData);
      }

      this.spinnerService.show(`${this.isEdit ? 'Salvando' : 'Criando'} saldo inicial...`);
      saveOperation.subscribe({
        next: () => {
          this.retornarMensagemSucesso(
            `Saldo Inicial ${this.isEdit ? 'atualizado' : 'criado'
            } com sucesso.`
          );
          this.saldoInicialDialog = false;
          this.loadInitialData();
        },
        error: (e: any) => {
          this.spinnerService.hide();
          this.retornarMensagemErro(e);
        },
      });
    }
  }

  applyFilterGlobal(event: Event, stringVal: string): void {
    this.dt?.filterGlobal((event.target as HTMLInputElement).value, stringVal);
  }

  retornarMensagemSucesso(mensagem: string): void {
    this.toastService.setMensagemToast(mensagem, SeveridadeToast.Success);
  }

  retornarMensagemErro(e: any): void {
    let errorMessage = 'Erro desconhecido';

    if (typeof e.error === 'string') {
      errorMessage = e.error;
    } else if (Array.isArray(e.error)) {
      errorMessage = e.error.join(', ');
    } else if (e.error?.message) {
      errorMessage = e.error.message;
    } else {
      console.error('Erro ao processar erro:', e);
    }

    this.toastService.setMensagemToast(
      `Erro ao processar Saldo Inicial: ${errorMessage}`,
      SeveridadeToast.Error
    );
  }

  ajustaTamanhoCampo(valor: string): string {
    return this.ajustaTamanhoCampoHelper.ajustaTamanhoCampo(valor, 25);
  }

  viewDetails(saldoInicial: SaldoInicial): void {
    this.selectedSaldoInicial = saldoInicial;
    this.detailsDialogVisible = true;
  }

  private contasFilhasObserver: Observer<ContaFilha[]> = {
    next: (contasFilhas: ContaFilha[]) => {
      this.contasFilhas = contasFilhas;
      this.classificacaoOptions = contasFilhas.map((cf) => ({
        label: cf.nomeConta,
        value: cf.id,
      }));
    },
    error: (err) => {
      console.error('Erro ao obter Contas Filhas:', err);
    },
    complete: () => { },
  };

  getContaFilhaName(contaFilhaId: number | null): string {
    const contaFilha = this.contasFilhas.find((c) => c.id === contaFilhaId);
    return contaFilha ? contaFilha.nomeConta : 'Não encontrado';
  }
}
